export const textFieldComponentOverrides = {
    MuiTextField: {
        defaultProps: {
            variant: 'outlined',
            fullWidth: true
        }
    }
};
